import { DashboardSidebar, SubNavItem } from 'torqcloud-ui'
import { aolytics, sbomSecurity, analyticsBlueForceRedForce, analyticsMap, analyticsUnitReadiness } from '../../constants/routing'
import Chat from '../../icons/Chat'
import ShieldWarning from '../../icons/ShieldWarning'
import Analystics from '../../icons/Analystics'
import Filter from '../../icons/Filter'
import Loading from '../../icons/Loading'
import Share from '../../icons/Share'
import { GetAppPermissions, APP_TYPES } from '../../utils/permissions'
import useDataApps from '../../hooks/data/useDataApps'
import { ReactElement } from 'react'

const DashboardSidebarTorqCloud = props => {
  const apps = useDataApps()
  const appPermissions = GetAppPermissions()

  const appItems: { title: string; path: string; icon: ReactElement; childItems: ReactElement[] }[] = []

  if (appPermissions[APP_TYPES.TORQ_FLOW] && apps.some(app => app.appType === APP_TYPES.TORQ_FLOW)) {
    appItems.push({
      title: 'TorqFlow',
      path: apps.find(app => app.appType === APP_TYPES.TORQ_FLOW)!.url,
      icon: <Share fontSize="small" />,
      childItems: [],
    })
  }

  if (appPermissions[APP_TYPES.TORQ_DATA] && apps.some(app => app.appType === APP_TYPES.TORQ_DATA)) {
    appItems.push({
      title: 'TorqData',
      path: apps.find(app => app.appType === APP_TYPES.TORQ_DATA)!.url,
      icon: <Loading fontSize="small" />,
      childItems: [],
    })
  }

  if (apps.some(app => app.appType === APP_TYPES.TORQ_NLP)) {
    appItems.push({
      title: 'TorqNLP',
      path: apps.find(app => app.appType === APP_TYPES.TORQ_NLP)!.url,
      icon: <Filter fontSize="small" />,
      childItems: [],
    })
  }

  if (apps.some(app => app.appType === APP_TYPES.TORQ_ANALYTICS)) {
    appItems.push({
      title: 'TorqAnalytics',
      path: analyticsBlueForceRedForce(),
      icon: <Analystics fontSize="small" />,
      childItems: [
        <SubNavItem key={'bgf'} path={analyticsBlueForceRedForce()} title={'Blue Force / Red Force'} />,
        <SubNavItem key={'bgf'} path={analyticsUnitReadiness()} title={'Unit Readiness'} />,
        <SubNavItem key={'bgf'} path={analyticsMap()} title={'Map'} />,
      ],
    })
  }

  if (apps.some(app => app.appType === APP_TYPES.TORQ_SECURE)) {
    appItems.push({
      title: 'TorqSecure',
      path: sbomSecurity(),
      icon: <ShieldWarning fontSize="small" />,
      childItems: [
        <SubNavItem key={'bgf'} path={sbomSecurity()} title={'SBOM security'} />,
        <SubNavItem key={'bgf'} path={aolytics()} title={'Aolytix'} />,
      ],
    })
  }

  if (appPermissions[APP_TYPES.TORQ_AGENT] && apps.some(app => app.appType === APP_TYPES.TORQ_AGENT)) {
    appItems.push({
      title: 'TorqAgent',
      path: apps.find(app => app.appType === APP_TYPES.TORQ_AGENT)!.url,
      icon: <Chat fontSize="small" />,
      childItems: [],
    })
  }

  const sections = [
    {
      title: 'Modules',
      items: appItems,
    },
  ]

  return <DashboardSidebar sections={sections} logoLinkUrl="/" onMobileClose={props.onMobileClose} openMobile={props.openMobile} />
}

export default DashboardSidebarTorqCloud
